import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=742ef2ce&scoped=true&"
import script from "./drag.vue?vue&type=script&lang=ts&"
export * from "./drag.vue?vue&type=script&lang=ts&"
import style0 from "./drag.vue?vue&type=style&index=0&id=742ef2ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ef2ce",
  null
  
)

export default component.exports